module.exports = __webpack_public_path__ + "fonts/5710ccd.woff";